var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"v-component",attrs:{"tile":_vm.tile}})
}
var staticRenderFns = []

export { render, staticRenderFns }